export const breakpoints = {
  xs: 0,
  sm: 420,
  md: 720,
  lg: 960,
  xl: 1220,
};
